import React, { Component } from 'react';
import LoginForm from './LoginForm';

class App extends Component {
  render() {
    return <LoginForm />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js